<nav #header *ngIf="renderMenu" class=" fixed-top headerStyle"
    [ngClass]="{'navbar2': this.companyParamsService.getFadeMenu()}"
    style='background-color: black;filter: drop-shadow(1px 1px 1px #6666664d);'>
    <div style="background-color: black; height:90px" class="desktop-container">
        <div style="border-bottom: 1px solid white;">
            <div #header1 class="container green containerMenu" style="justify-content: space-between;">
                <div *ngIf="companyParamsService.getHasLogoInformation()" class="tooltip fade show bs-tooltip-right"
                    role="tooltip" id="tooltip164687" x-placement="right"
                    style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(266px, 24px, 0px);">
                    <div class="arrow" style="top: 8px;"></div>
                    <div class="tooltip-inner">Your Logo Here</div>
                </div>
                <a *ngIf="!this.companyParamsService.getWebSite()" class="navbar-brand" target="_blank"
                    class="navbar-brand" data-container=".green" data-toggle="tooltip" data-placement="right"
                    title="Your Logo Here">
                    <img src="https://gulliver.com.ec/wp-content/uploads/2018/08/LOGOTIPO-GULLIVER-FINAL-WEB.png"
                        height="46" alt="logo" class="brand-logo">
                </a>
                <a *ngIf="this.companyParamsService.getWebSite()" href="https://gulliver.com.ec" class="navbar-brand"
                    target="_blank">
                    <input type="hidden" value="{{this.companyParamsService.getCompanyParams().logoFade}}"
                        id="logoFade">
                    <input type="hidden" value="{{this.companyParamsService.getCompanyParams().fadeMenu}}"
                        id="fadeMenu">
                    <span class="custom-logo" width="180" height="46"></span>
                </a>
                <div style="display: contents;">
                    <div class="containerMenu navbar-collapse collapse"
                        style="flex-basis: 0%; align-items: end; justify-content: end; flex-direction: column; gap:10px">
                        <div>
                            <a class="top-bar-button" href="https://gulliver.com.ec/ecuador-tours/sale-tours/"
                                style="margin-right:10px;">Get our best deals</a>
                            <a class="top-bar-button" href="https://gulliver.com.ec/ecuador-tours/contact-us/"
                                style="margin-right:10px;">Talk with an expert</a>
                            <a href="tel:+13158599622">US Toll Free: (+1) 315-859-9622</a>
                        </div>
                        <ul class="navbar-nav menuContainer" style="width: inherit;">
                            <li class="nav-item menuItem"><a href="https://gulliver.com.ec/ecuador-activities/"
                                    target="_blank">ECUADOR</a></li>
                            <li class="nav-item menuItem"><a href="https://gulliver.com.ec/climbing-tours/"
                                    target="_blank">CLIMBING</a>
                            </li>
                            <li class="nav-item menuItem"><a href="https://gulliver.com.ec/galapagos-islands-tours/"
                                    target="_blank">GALAPAGOS</a>
                            </li>
                            <li class="nav-item menuItem"><a href="https://gulliver.com.ec/peru-tours/"
                                    target="_blank">PERU</a>
                            </li>
                            <li class="nav-item menuItem"><a href="https://gulliver.com.ec/bolivia-tours/"
                                    target="_blank">BOLIVIA</a>
                            </li>
                            <li class="nav-item menuItem"><a href="https://gulliver.com.ec/webinars/"
                                    target="_blank">WHAT'S NEW</a>
                            </li>
                            <li class="nav-item menuItem"><a href="https://gulliver.com.ec/ecuador-tours/contact-us/"
                                    target="_blank">CONTACT US</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="button-container">
                    <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
                        <app-heart-header></app-heart-header>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="responsiveHeader">
        <div class="container green containerHeader"
            style="display:flex; flex-direction: row!important;align-items: center; justify-content: space-between;">
            <a class="menuButton" (click)="renderMenu()" href="javascript:void()" style="padding-left: 10px;">
                <i class="fa fa-bars fa-2x"></i>
            </a>
            <img src="../assets/images/logos-header/ge.svg" width="129" />
            <div></div>
        </div>
    </div>
    <ul style="width: inherit; display: none;" class="menuContainer" [ngClass]="showMenu ? 'showMenu':''">
        <li class="nav-item menuItem"><a href="https://gulliver.com.ec/ecuador-activities/" target="_blank">Ecuador</a>
        </li>
        <li class="nav-item menuItem"><a href="https://gulliver.com.ec/climbing-tours/" target="_blank">Climbing</a>
        </li>
        <li class="nav-item menuItem"><a href="https://gulliver.com.ec/galapagos-islands-tours/"
                target="_blank">Galapagos</a>
        </li>
        <li class="nav-item menuItem"><a href="https://gulliver.com.ec/peru-tours/" target="_blank">Peru</a>
        </li>
        <li class="nav-item menuItem"><a href="https://gulliver.com.ec/bolivia-tours/" target="_blank">Bolivia</a>
        </li>
        <li class="nav-item menuItem"><a href="https://gulliver.com.ec/webinars/" target="_blank">What's new</a>
        </li>
        <li class="nav-item menuItem"><a href="https://gulliver.com.ec/ecuador-tours/contact-us/"
                target="_blank">Contact Us</a>
        </li>
    </ul>
    <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container"
        [ngClass]="showMenu ? 'showMenu':''" style="width: inherit; display: none;">
        <app-heart-header></app-heart-header>
    </div>
</nav>